export const mergeAccounts = async (adskToken, handleError, handleSuccess) => {
  const bearer = `Bearer ${localStorage.getItem('userToken')?.slice(1, -1)}`;
  try {
    const mergeResp = await fetch(`${API_URL}/merge-account`, {
      method: 'POST',
      headers: {
        Authorization: bearer,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ code: adskToken }),
      credentials: 'include',
    });
    const respData = await mergeResp.json();

    if (!respData.success) {
      handleError(respData);
    } else {
      handleSuccess(respData);
    }
  } catch (error) {
    handleError(error);
  }
};

export const checkMergePossible = async (
  adskToken,
  handleError,
  handleSuccess
) => {
  const userToken = localStorage.getItem('userToken');
  let token = userToken ? userToken.slice(1, -1) : '';

  try {
    const mergeResp = await fetch(`${API_URL}/check-merge-account-possible`, {
      method: 'POST',
      headers: {
        authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ code: adskToken }),
      credentials: 'include',
    });
    const respData = await mergeResp.json();

    if (respData.success && respData.can_be_merged && respData.same_account) {
      return mergeAccounts(adskToken, handleError, handleSuccess);
    } else if (
      respData.success &&
      !respData.can_be_merged &&
      !respData.same_account
    ) {
      handleError(respData);
    } else if (
      respData.success &&
      respData.can_be_merged &&
      !respData.same_account
    ) {
      handleError(respData);
    }
  } catch (error) {
    console.log('error');
    handleError(error);
  }
};

export default { checkMergePossible, mergeAccounts };
